import ReactGA from 'react-ga';
import { call, select, takeEvery } from 'redux-saga/effects';

import { profileSelector, isLoginSelector } from '../../client/selector/user';
import { isMobileSelector } from '../../client/selector/device';
import { getLinkTracking } from '../utils/deeplink';
import sendLegacyEvent from '../utils/tracking/sendLegacyEvent';
import { LOGOUT, AUTH_FLOW_END } from '../constants/actionTypes';

export function* trackingProfile() {
  const isLogin = yield select(isLoginSelector);
  const profile = yield select(profileSelector);
  const isMobile = yield select(isMobileSelector);
  const linkTracking = yield call(getLinkTracking);

  yield call(sendLegacyEvent, {
    api: 'user_profile',

    profile,
    isMobile,

    event1: linkTracking.utm_term,
    event2: linkTracking.utm_campaign,
    event3: linkTracking.referring_link,
    event4: linkTracking.utm_content,
    event5: linkTracking.utm_medium,
    event6: linkTracking.utm_source,
  });

  yield call(ReactGA.set, {
    dimension1: profile?.isVip ? 'SVOD' : 'AVOD',
    dimension2: isLogin ? profile.social?.[0]?.provider ?? 'email' : 'not_login',
  });
}

function* unsetGAProfile() {
  yield call(ReactGA.set, {
    dimension1: 'AVOD',
    dimension2: 'not_login',
  });
}

export function* trackingProfileFlow() {
  yield takeEvery(AUTH_FLOW_END, trackingProfile);
  yield takeEvery(LOGOUT, unsetGAProfile);
}
